import { UserAPI } from '@/api/backend-client'

const currentUserCanViewReports = async () => {
    const currentUser = await UserAPI.getCurrentUser()
    return currentUser.canViewReports
}

export default [
    {
        name: 'reports_parent',
        path: '/reports',
        redirect: { name: 'reports' },
        meta: {
            condition: currentUserCanViewReports,
        },
        component: () => import(/* webpackChunkName: "reports_parent" */ '../../views/Reports/Reports.vue'),
        children: [
            {
                name: 'reports',
                path: '',
                meta: {
                    condition: currentUserCanViewReports,
                    noBackground: false ,
                },
                component: () => import(/* webpackChunkName: "reports" */ '../../views/Reports/Overview.vue'),
            },
            {
                name: 'report',
                path: ':dashboardId',
                props: true,
                meta: {
                    condition: currentUserCanViewReports,
                    noBackground: false,
                    showScrollbar: false,
                },
                component: () => import(/* webpackChunkName: "report" */ '../../views/Reports/Report.vue'),
            },
        ],
    },
]
